export const MATCH_REQUEST = 'MATCH_REQUEST';
export const MATCH_SUCCESS = 'MATCH_SUCCESS';
export const MATCH_FAIL = 'MATCH_FAIL';
export const MATCH_LIVE_SUCCESS = 'MATCH_LIVE_SUCCESS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
